<template>
  <div class="amprod-cart-empty">
    <div class="empty-cart-icon">🛒</div>
    <h3>Your cart is empty</h3>
    <p>Configure a product and add it to your quote request to get started.</p>
  </div>
</template>

<script>
export default {
  name: "CartEmptyState",
};
</script>

<style scoped>
.amprod-cart-empty {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.empty-cart-icon {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.5;
}

.amprod-cart-empty h3 {
  margin: 0 0 10px 0;
  color: #999;
}
</style>
